import { render, staticRenderFns } from "./PriceListInfo.vue?vue&type=template&id=4a5237fb&"
import script from "./PriceListInfo.vue?vue&type=script&lang=js&"
export * from "./PriceListInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports